'use strict';

var _regeneratorRuntime = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/home/runner/work/dapp-ipfs-drive/dapp-ipfs-drive/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var errCode = require('err-code');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function resolve(_x, _x2, _x3, _x4, _x5) {
  return _resolve.apply(this, arguments);
}

function _resolve() {
  _resolve = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid$1, path, codecs, getBlock, options) {
    var load, parts, value, lastCid, key, _cid$;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            load = /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid) {
                var codec, block;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return codecs.getCodec(cid.code);

                      case 2:
                        codec = _context.sent;
                        _context.next = 5;
                        return getBlock(cid, options);

                      case 5:
                        block = _context.sent;
                        return _context.abrupt("return", codec.decode(block));

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function load(_x6) {
                return _ref.apply(this, arguments);
              };
            }();

            parts = path.split('/').filter(Boolean);
            _context2.next = 4;
            return _awaitAsyncGenerator(load(cid$1));

          case 4:
            value = _context2.sent;
            lastCid = cid$1;

          case 6:
            if (!parts.length) {
              _context2.next = 25;
              break;
            }

            key = parts.shift();

            if (key) {
              _context2.next = 10;
              break;
            }

            throw errCode__default["default"](new Error("Could not resolve path \"".concat(path, "\"")), 'ERR_INVALID_PATH');

          case 10:
            if (!Object.prototype.hasOwnProperty.call(value, key)) {
              _context2.next = 16;
              break;
            }

            value = value[key];
            _context2.next = 14;
            return {
              value: value,
              remainderPath: parts.join('/')
            };

          case 14:
            _context2.next = 17;
            break;

          case 16:
            throw errCode__default["default"](new Error("no link named \"".concat(key, "\" under ").concat(lastCid)), 'ERR_NO_LINK');

          case 17:
            _cid$ = cid.CID.asCID(value);

            if (!_cid$) {
              _context2.next = 23;
              break;
            }

            lastCid = _cid$;
            _context2.next = 22;
            return _awaitAsyncGenerator(load(value));

          case 22:
            value = _context2.sent;

          case 23:
            _context2.next = 6;
            break;

          case 25:
            _context2.next = 27;
            return {
              value: value,
              remainderPath: ''
            };

          case 27:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _resolve.apply(this, arguments);
}

exports.resolve = resolve;